import type { TranslateFn } from "@app/_utils/interpolate";

import {
  TITLE_DELIMITER,
  TITLE_PAGE_NUMBER_DELIMITER,
  TITLE_PAGE_NUMBER_PREFIX,
  TITLE_SITE_NAME,
} from "@/utils/const";

type Props = {
  defaultTitle: string | null | undefined;
  pageNumber?: number;
  t: TranslateFn;
};

export default function getPageNumberTitle(props: Props): string {
  const { defaultTitle, pageNumber, t } = props;

  if (!defaultTitle) {
    return t("titleSiteName") || TITLE_SITE_NAME;
  }

  const [first] = (defaultTitle ?? "").split(TITLE_DELIMITER);

  let title = first;

  if (pageNumber && pageNumber > 1) {
    const currentPage = ` ${TITLE_PAGE_NUMBER_DELIMITER} ${
      t("titlePageNumberPrefix") || TITLE_PAGE_NUMBER_PREFIX
    } ${pageNumber}`;
    title += currentPage;
  }

  title = title.replace(/  +/g, " ");

  return title.trim();
}
